export class CategoryModel {
    public id: number;
    public parentId: number;
    public categoryTypeId: number;
    public name: string;
    public levelNo: number;
    public orderNo: number;
    public isActive: boolean;
}